// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const MEDIATOR_DASHBOARD = '/mediatore';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: '/',
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  page404: '/404',
};

export const PATH_DASHBOARD = {
  root: MEDIATOR_DASHBOARD,

  // Mediator Paths
  mediatorDashboard: path(MEDIATOR_DASHBOARD, '/app'),
  mediatorBookings: path(MEDIATOR_DASHBOARD, '/richiesta'),
  mediatorBookingsView: (id) => path(MEDIATOR_DASHBOARD, `/richiesta/${id}`),
  mediatorProfile: path(MEDIATOR_DASHBOARD, '/profilo'),
  fatturazione: path(MEDIATOR_DASHBOARD, '/fatturazione'),
  invoice: path(MEDIATOR_DASHBOARD, '/invoice'),
  // invoiceNew: path(MEDIATOR_DASHBOARD, '/invoice-new'),
  invoiceDetail: (id) => path(MEDIATOR_DASHBOARD, `/invoice/${id}`),
  translationOrders: path(MEDIATOR_DASHBOARD, '/traduzioni'),
};
